
import React, { useEffect, useState } from 'react'; 
import ListTemplate from '../../../Reusable_Components/ListTemplate';  
import axios from 'axios'; 
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';  

const PaymentListDetails = ({ invoiceId }) => { 
  const [payments, setPayments] = useState([]); 

  useEffect(() => { 
    const fetchPayments = async () => { 
      try {        
        let url = "";
        if (invoiceId) {            
            const url =  `${API_DOMAIN}${API_ROUTES.payment}?invoice_id=${invoiceId}`;
        }
        else
        {
            const url = `${API_DOMAIN}${API_ROUTES.payment}`;
        }
        const token = localStorage.getItem('token');          
        const response = await axios.get(url, { headers }); 
        setPayments(response.data); 
      } catch (error) { 
        console.error('Error fetching payments:', error); 
      } 
    }; 

    fetchPayments(); 
  }, [invoiceId]); 

  const columns = [ 
    { label: 'Payment ID', value: 'payment_id' }, 

    { label: 'Amount Paid', value: 'amount_paid' }, 
    { label: 'Payment Date', value: 'payment_date' }, 
    { label: 'Payment Method', value: 'payment_method' }, 
    { label: 'Status', value: 'status' }, 
    { label: 'Transaction Reference', value: 'transaction_reference' }, 
    { label: 'Created At', value: 'created_at' }, 
  ]; 

  const handleViewDetails = (paymentId) => { 
    //console.log('View Details', paymentId); 
    const encodedId = btoa(paymentId);
    window.location.href = `/payment/details/${encodedId}`; 
  }; 

  const actionButtons = [ 
    { label: 'View Details', handler: handleViewDetails }, 
  ]; 

  return <ListTemplate columns={columns} data={payments} actionButtons={actionButtons} />; 
}; 

export default PaymentListDetails;
